module.exports = __webpack_public_path__ + "media/banners/ubezpieczenia-baner-2de1b1b5.png";